const fields = ['what', 'why', 'where', 'who', 'when', 'how', 'howMuch', 'observation']

export { fields }